import lodash from "lodash";

export const getGroupType = (group, groupTypes) => {
  if (!group) {
    return null;
  }
  return lodash.get(groupTypes, group.type, {
    name: group.type,
  });
};

export const isSupportedGroupType = (groupType) => {
  if (groupType) {
    return (
      groupType.isSupply ||
      groupType.isDemand ||
      groupType.isRoot ||
      groupType.isDirectoryVisible
    );
  }
  return false;
};

export const getRootGroupTypeIds = (groupTypes) =>
  lodash.flatMap(groupTypes, (groupType) => {
    return lodash.get(groupType, "isRoot") ? lodash.get(groupType, "id") : [];
  });

export const groupTypeAsText = (groupType) => {
  return groupType?.displayName || groupType?.name || groupType?.id;
};
